import config from '@/config';
import { extractControllersData } from '@/logic/controllers';
import { HOMEPAGE_BASE_PATH } from '@/logic/main/constants';
import { LogicContext } from '@/logic/main/types';
import { extractNavigationLinksFromNavComponent } from '@/logic/main/utils';
import Location from '@/ports-frontend/Location';
import Window from '@/ports-frontend/Window';

export async function fetchPageInfo(
  context: LogicContext,
  event: { data: { [key: string]: any } }
) {
  const preloadedLayout = await Window.getInitialPresenterLayout();
  if (preloadedLayout && preloadedLayout.renderManifest) {
    const { renderManifest, id, trackingInfo, properties } = preloadedLayout;
    let pageTrackingData = trackingInfo;
    const { liveDealerTables = [], personalizedBanners = [] } =
      renderManifest || {};

    const navigationLinks = extractNavigationLinksFromNavComponent(
      renderManifest.components.StaticNavigation,
      context.currentScreenSize
    );

    const isSidebarInLayout = !!Object.entries(renderManifest.components).find(
      ([key, values]: [string, any]) =>
        key === 'Modal' && values.children.length
    );

    const isModalInLayout = !!Object.entries(renderManifest.components).find(
      ([key, values]: [string, any]) => {
        return key === 'GameDetailsModal' && values.children.length;
      }
    );

    const isVideoEnabled = !!Object.entries(renderManifest.components).find(
      ([key, values]: [string, any]) => {
        return key === 'VideoModal' && values.properties.visible;
      }
    );

    if (isSidebarInLayout) {
      pageTrackingData = {
        ...pageTrackingData,
        page: {
          ...pageTrackingData,
          SiteSectionCategory:
            context.trackingData?.page?.SiteSectionCategory ||
            pageTrackingData['SiteSectionCategory'] ||
            'Featured',
        },
      };
    }

    const controllersData = extractControllersData(
      Object.entries(renderManifest.components)
    );
    const mainLayoutPath = `${config.base_path || ''}${id}`;

    if (!config.history.enabled) {
      return {
        isLayoutPreloaded: !!preloadedLayout,
        path: mainLayoutPath,
        currentPagePath: mainLayoutPath,
        trackingInfo: pageTrackingData,
        liveDealerTables,
        personalizedBanners,
        pageTitle: properties.pageTitle,
        controllersData,
        mainLayoutPath,
        initialRequest: false,
        navigationLinks: navigationLinks || context.navigationLinks,
        isSidebarInLayout,

        isVideoEnabled,
        isErrorPage:
          properties.status === 'NOT FOUND' ||
          properties.status === 'NOT_FOUND',
      };
    }
    const location = await Location.get();

    return {
      initialRequest: !event.data.location,
      path: location.pathname,
      currentPagePath: location.pathname,
      trackingInfo: pageTrackingData,
      isLayoutPreloaded: !!preloadedLayout,
      liveDealerTables,
      personalizedBanners,
      mainLayoutPath: HOMEPAGE_BASE_PATH,
      pageTitle: properties.pageTitle,
      controllersData,
      navigationLinks: navigationLinks || context.navigationLinks,
      isSidebarInLayout,
      isModalInLayout,
      isVideoEnabled,
      isErrorPage:
        properties.status === 'NOT FOUND' || properties.status === 'NOT_FOUND',
    };
  }
  if (!config.history.enabled) {
    return {
      initialRequest: true,
      isLayoutPreloaded: !!preloadedLayout,
      path: HOMEPAGE_BASE_PATH,
    };
  }
  const location = await Location.get();

  return {
    initialRequest: !event.data.location,
    path: location.pathname,
    isLayoutPreloaded: !!preloadedLayout,
  };
}
